import { getErrorMessage } from '../error'

export { cn } from '../utils'

// Placeholder function for server/edge environments
const serverShowErrorAlert = (error: any): void => {
  console.error('Error (server-side):', error)
}

// Client-side implementation with dynamic import
const clientShowErrorAlert = async (error: any): Promise<void> => {
  try {
    const { default: Swal } = await import('sweetalert2')
    const { title, message } = getErrorMessage(error)

    Swal.fire({
      icon: 'error',
      title,
      html: message
    })
  } catch (importError) {
    console.error('Failed to load SweetAlert2:', importError)
    console.error('Original error:', error)
    // Fallback to browser alert
    alert(`${getErrorMessage(error).title}: ${getErrorMessage(error).message}`)
  }
}

/**
 * Exibe um alerta de erro usando SweetAlert2 ou fallback para alert
 * @param error Erro a ser exibido
 */
export const showErrorAlert =
  typeof window === 'undefined' ? serverShowErrorAlert : clientShowErrorAlert
